module.exports = (__webpack_require__(1206))(8331);